import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../context/AuthContext';

const ClientModal = ({ isOpen, onClose, onSave, client }) => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (client) {
      setFormData({ name: client.name || '', phone: client.phone || '' });
    } else {
      setFormData({ name: '', phone: '' });
    }
  }, [client, isOpen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (formData.name) {
      onSave(formData, client?._id);
    } else {
      toast.error("Le nom du client est obligatoire.");
    }
  };

  if (!isOpen) return null;
  
  // Un vendeur ne peut pas éditer, seulement ajouter.
  const isEditing = !!client;
  const canEdit = user?.role === 'owner';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
        <h3 className="text-xl font-semibold mb-4">{isEditing ? 'Modifier le client' : 'Ajouter un nouveau client'}</h3>
        <label className="block text-sm font-medium text-gray-700 mb-1">Nom du client</label>
        <input name="name" type="text" placeholder="Nom du client" value={formData.name} onChange={handleChange} className="w-full p-2 border rounded mb-4" disabled={isEditing && !canEdit} />
        <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
        <input name="phone" type="text" placeholder="Téléphone (optionnel)" value={formData.phone} onChange={handleChange} className="w-full p-2 border rounded mb-4" />
        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg">Annuler</button>
          <button onClick={handleSave} className="bg-brand-green hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed" disabled={isEditing && !canEdit}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
};

export default ClientModal;